import { message } from "@/assets/lang/lang-cn";
import { title } from "@/settings";
import { plan } from "echarts/lib/chart/candlestick/candlestickVisual";

export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传",
    enable:"启用",
    disable:"禁用",
    close:"关闭",
    view:"查看",
    confirm:"确定",
    batchUpdateSwitchCode:"批量修改通道",
    batchUpdateStatus:"批量修改状态",
    reset: "重置"
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"开始时间",
    endTime:"结束时间",
    creator:"创建人",
    createdBy:"创建用戶",
    updater:"更新人",
    updatedBy:"更新用戶",
    createTime:"创建时间",
    createdAt:"创建时间",
    updateTime:"更新时间",
    updatedAt:"创建时间",
    phone:"手机号",
    name:"姓名",
    email:"邮箱",
    idNumber:"身份证号码",
    status:"状态",
    remark:"备注",
    fromTime: {
      label: "从",
      placeholder: "创建时间"
    },
    toTime: {
      label: "至",
      placeholder: "创建时间"
    }
  },
  /*用户追踪页面*/
  kscore:{
    month:"活动期数",
    profit:"收益",
    detail:"详情",
    symbol:'产品名称',
    direction:'买卖方向',
    openPrice:'开仓价格',
    closePrice:'平仓价格',
    createTime:'平仓时间',
  },
  registerLog:{
    dataType:"数据类型",
    driverType:"设备类型",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    ipAddress:"IP所在地",
    href:"来源URL",
    referrer:"着陆页",
    directPhone:"推荐人手机号",
    phonePre:"手机区号",
    title:"性别",
    businessType:"业务组",
    ruleId:"短信规则id",
    register:"原始客户名单",
  },
  accountReward:{
    activeId:"活动ID",
    activeStatus:"活动状态",
    activeName:"活动名称",
    activeType:"活动类型",
    proposalNo:"提案号",
    beginDate:"活动开始时间",
    endDate:"活动结束时间",
    expDay:"有效期",
    proposalUser:"提案人",
    proposalDate:"提案时间",
    approvalUser:"审批人",
    approvalDate:"审批时间",
    proposalType:"提案类型",
    proposalStatus:"提案状态",
    applyProposal:"执行提案",
    cancelProposal:"取消提案",
    applySuccess:"执行成功",
    applyFail:"执行失败",
    choiceOne:"请选择一条提案",
    notSatisfiable:"提案不符合要求",
    downloadProActivity:"推荐赠金活动提案",
    excuteCustomerNumber:'会员账号',
    demo:'账户类型',
    levelType:'账户级别',
    mobilePhone:'电话',
    chineseName:'姓名',
    directPhone:'直接推荐人',
    directindirect:'直接/间接推荐人',
    indirectPhone:'间接推荐人',
    symbolType:'产品类型',
    execVolume:'交易笔数',
    complianceExecVolume:'客户交易手数/达标手数',
    complianceStatus:'达标状态',
    ctime:'达标时间',
    userCreateDate:'开户时间',
    activeTime:'激活时间',
    downloadEffectiveCustomer:'有效客户记录',
    downloadActivity:'交易返利活动',
    downloadActivity0:'推荐赠金活动',
  },
  rewardTradeDetails:{
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算账号手机号',
    currentChineseName:'结算账号姓名',
    excuteCustomerNumber:'客户交易账号',
    mobilePhone:'客户手机号',
    demo:'账户类型',
    levelType:'账户级别',
    symbolType:'产品类型',
    symbol:'产品',
    orderid:'持仓号',
    execVolume:'交易笔数',
    relationType:'奖励类型',
    directPhone:'直接推荐人',
    indirectPhone:'间接推荐人',
    currentRebete:'金额',
    ctime:'结算时间',
    downloadTradeDetails:'奖励明细记录',
  },
  rewardDealList:{
    createDate:'结算时间',
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算手机号',
    currentChineseName:'结算客户姓名',
    customerStatus:'账户状态',
    currentRebete:'奖励金额',
    correctionRebete:'调整金额',
    finalRebete:'最终返利',
    proposalStatus:'状态',
    updateUser:'修改人',
    updateDate:'修改时间',
    approvalUser:'审批人',
    approvedDate:'审批时间',
    remark:'备注(拒绝原因)',
    confirmSubmit:'确认提交',
    confirmSuccess:"提交成功",
    confirmFail:"提交失败",
    cancel:'取消',
    confirm:'确定',
    cancelProposal:'取消提案',
    refuse:'拒绝提案',
    apply:'审批',
    reason:'原因',
    limit:'额度调整表',
    refuseProposal:'拒绝',
    downloadLimit:'下载额度调整表'
  },
  relationList:{
    customerRelation:'用户推荐关系',
    customerRelationPro:'用户推荐关系提案',
    customerNum:'交易账号',
    mobilePhone:'手机号码',
    userName:'姓名',
    userLevel:'账户级别',
    createDate:'开户日期',
    activeTime:'激活时间',
    newdirectPhone:'直接推荐人',
    remark:'备注',
    customerNumber:'会员账号',
    phone:'电话',
    direct:'直接/间接推荐人',
    matchType:'推荐关系',
    activeStatus:'激活状态',
    demoCustomerNum:'模拟账号',
    directNumber:'直接推荐人账号',
    directPhone:'直接推荐人手机',
    indirectNumber:'间接推荐人账号',
    indirectPhone:'间接推荐人手机',
    inviteCode:'邀请码',
    useInviteCode:'有无邀请码',
    directInviteCode:'直接推荐人邀请码',
    reStatus:'匹配结果',
    proposalUser:'提案人',
    proposalDate:'提案时间',
    approvalUser:'审批人',
    approvalDate:'审批时间',
    applyProposal:"执行提案",
    cancelProposal:'取消提案',
    beginDate:'开户开始时间',
    endDate:'开户结束时间',
    proposalStatus:'提案状态',
    proposalNo:'提案号',
  },
  faceConfig:{
      deleteSuccess:'删除成功!',
      updateSuccess:'修改成功!',
      code:'通道编码',
      name:'通道名称',
      type:'验证类型',
      thirdParty:'第三方接口',
      cost:'费用',
      status:'状态',
      statusUpdateBy: '开关更新用户',
      statusUpdateDate: '开关更新时间',
      remark:'备注',
      verifyCode:'厂家通道',
      verifyType:'验证类型',
      verifyTypeCN:'验证类型中文',
      describe:'验证描述',
      device:'平台类型',
      channel: '渠道名称',
      channelDesc: '渠道名称，例如Android: cf / iOS: com.cfd.cf',
      version: '版本号',
      versionDesc: '版本号，例如Android: 111 / iOS: 1.1.1',
      switchCode: '通道切换',
      faceStatus: '人脸控制',
      createDate : '创建时间',
      createUser: '创建人',
      updateUser: '修改人',
      updateDate: '修改时间',
      submitSuccess:'操作成功',
      faceRecord:'验证记录',
      chineseName: '姓名',
      card: '身份证',
      phone: '手机号',
      recordDate: '记录时间',
      channelName : '通道名称',
      result: '比对结果',
      resultParam: '查询输出',
      count: '使用次数',
      successCount: '成功次数',
      artificialCount: '人工调用成功次数',
      systemCount: '系统调用成功次数',
      needSelectRecord: '请先选择最少一个记录',
      channelExportButton: '导出开关记录',
  },
  creditLevel:{
     updateList:'信用等级修改列表',
     journal:'修改日志',
     batchImport:'批量导入',
     uploadTip:'将文件拖到此处，或',
     uploadTip1:'点击上传',
     uploadTip2:'只能上传xlsx文件，且不超过10M',
     uploadSuc:'文件上传成功',
     uploadFail:'文件上传失败',
     downTemplate:'下载模板',
     uploadFile:'立即上传',
     batchUpdate:'批量修改',
     customerNo: '会员账号',
     pkey: 'P标签',
     creditLevelOld: '修改前的信用等级',
     creditLevelOriginal: '当前用户信用等级',
     creditLevel:'信用等级',
     remark:'备注',
     createDate :'创建时间',
     createUser: '创建人',
     updateUser: '修改人',
     updateDate: '修改时间',
  },
  starLevel:{
     updateList:'星级修改列表',
     journal:'修改日志',
     batchImport:'批量导入',
     uploadTip:'将文件拖到此处，或',
     uploadTip1:'点击上传',
     uploadTip2:'只能上传xlsx文件，且不超过10M',
     uploadSuc:'文件上传成功',
     uploadFail:'文件上传失败',
     downTemplate:'下载模板',
     uploadFile:'立即上传',
     batchUpdate:'批量修改',
     customerNo: '会员账号',
     starLevelOld: '修改前的星级',
     starLevelOriginal: '当前用户星级',
     starLevel:'星级',
     remark:'备注',
     createDate :'创建时间',
     createUser: '创建人',
     updateUser: '修改人',
     updateDate: '修改时间',
     update:'修改',
     dataType:'修改类型',
  },
  rebateComponents:{
    subtotal:'小计',
    total:'总计',
    tradeLogList:'返利明细记录详情',
    cancel:'取消',
    confirm:'确认',
    symbolType:'产品类型',
    displayName:'产品',
    orderId:'持仓号',
    execVolume:'交易手数',
    rebateAmount:'返利金额',
    activeName:'活动名称',
    activity:'活动时间',
    activeId:'活动ID',
    effective:'有效客户条件设置',
    tips:'新客户开户和激活时间必须在该活动期限内',
    beginDate: "开始时间",
    endDate: "结束时间",
    expDate: "有效期起始日",
    expDay: "有效期",
    productType: "产品类型",
    me: "客户",
    direct: "直接推荐",
    indirect: "间接推荐",
    quantity: "交易笔数要求",
    highAmount:'最高奖励金额',
    highAmount2:'新客户最高贡献返利',
    highPoint:'客户推荐累计获得最高返利',
    add:'新增',
    update:'修改',
    dollar:'美元',
    day:'天',
    activeTime:'激活日期',
    reward:'推荐赠金设置',
    rebate:'交易返利设置',
    addCondition:'添加条件',
    min:'迷你',
    std:'标准',
    vip:'金钻',
    to:'至',
    all:'全部',

  },
  risk:{
    name:"网关名称",
    baseSetting:"基础用户配置",
    specialSetting:"特定用户配置",
    ipSetting:"ip规则配置",
    addBaseSetting:"新增规则用户群",
    addspecialSetting:"新增特定用户群",
    settingTpye:"配置类型",
    userType:"用户群体",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    limitSetting:"限制规则",
  },
  registervalidate:{
    customerNo:"账号",
    registerType:"开户类型",
    target:"标签",
    creditTunnel2:"征信通道2",
    creditTunnel3:"征信通道3",
    validateStatus2:"二元素验证状态",
    validateStatus3:"三元素验证状态",
    registerStatus:"开户状态",
    channel:"渠道来源",
    kycResult:"kyc验证结果",
    personMarkTunnel:"征信诉讼通道",
    personMarkResult:"征信诉讼验证结果",
    creditLoanTunnel:"征信逾期通道",
    creditLoanResult:"征信逾期验证结果",
  },
  tracker:{
    customerNo:"用户账号",
    openStartTime:"开户开始时间",
    openEndTime:"开户结束时间",
    activeStartTime:"激活开始时间",
    activeEndTime:"激活结束时间",
    userType:"账号类型",
    isActive:"激活状态",
    isShow:"列段显示/隐藏",
    businessType:"业务组",
    relatedAccount:"关联账号",
    levelType:"账号级别",
    userAge:"年龄",
    gender:"性别",
    birthday:"出生日期",
    ctime:"开户日期",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    href:"来源url",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    activeTime:"激活时间",
    ipAddress:"IP所在地",
    userAgent:"浏览器",
    checkStatus:"IVI验证状态",
    arbitrageurTags:"IVI验证标记",
    directAccount:"推荐人帐号",
    directPhone:"推荐人手机号",
    tracker:"用户追踪",
    inviteCode:'邀请码',
    isInviteCode:'有无邀请码',
    directInviteCode:'推荐人邀请码'
  },
  activeTemplate:{
    type:"活动类型",
    url:"发布域名",
    detail:"模块模板",
    field:"广告属性",
    fieldTitle:"属性名称",
    fieldField:"属性编码",
    fieldType:"属性类型",
    text:"文字",
    img:"图片",
    title:"模板标题",
    activeTime:"活动时间",
    author:"发布人",
  },
  advertising:{
    key: "键",
    value: "值",
    type: "类型",
    createTime:"创建时间",
    name:"广告名称",
    platform:"应用平台",
    term:"有效期",
    accountType:"账户类型",
    isActive:"激活状态",
    userLevel:"账户级别",
    aboutType:"转换度",
    position:"广告位置",
    positionType:"广告类型",
    channel:"渠道",
    channelKey: "渠道代号",
    channelName:"渠道名称",
    addChannel:'新增渠道',
    adverInfo:"广告详情",
    startTime:"开始时间",
    endTime:"生效时间",
    status:"状态",
    carapace:"马甲包",
    time:"生效",
    param:"适用用户",
    url:"上传图片",
    title:"标题",
    address:"地址",
    content:"内容",
    sort:"排序",
    simulation:"模拟",
    real:"真实",
    demoCaseReal:"真实模拟转换",
    channelApp:"渠道App",
    channelAppName:"渠道App名称",
    addChannelApp:"新增APP",
    deleteChannelApp:"删除APP"
  },
  analy:{
    dayActive:"当日实时激活数",
    dayReal:"当日真实开户",
    dayDemo:"当日模拟开户",
    dayRealDemo:"当日真实+模拟开户",
    in:"其中",
    dayRealActive:"当天开户并激活数",
    weekActiveCount:"最近7天激活数",
    weekRealCount:"最近7天真实开户数",
    weekDemoCount:"最近7天模拟开户数",
    weekRealDemoCount:"最近7天真实+模拟开户数",
    realCount:"真实开户数",
    demoCount:"模拟开户数",
    realDemoCount:"真实+模拟开户数",
    averCount:"工作日平均线",
    week0:"星期日",
    week1:"星期一",
    week2:"星期二",
    week3:"星期三",
    week4:"星期四",
    week5:"星期五",
    week6:"星期六",
    dayActiveRate:"当日实时激活来源渠道占比",
    dayRealRate:"当日实时真实开户来源渠道占比",
    dayDemoRate:"当日实时模拟开户来渠道占比",
    dayRealDemoRate:"当日实时真实+模拟来源渠道占比",
    dayRealCount:"当日实时真实开户数",
    dayDemoCount:"当日实时模拟开户数",
    dayRealDemoCount:"当日实时+模拟真实开户数",
    today:"今天",
    yesterday:"昨天",
    activeCount:"激活数",
  },
  smsType:{
    device:"页面端",
    type:"验证码方式",
    updateTime:"修改时间",
    modify:"切换方式"
  },
  emailTemplate:{
    emailTemplate:"邮件模板",
    templateName:"模板名称",
    title:"邮件标题",
    enabled:"状态",
    updateDate: '更新时间',
  },
  emailSend:{
    sendEmail:"发送邮件",
    title:"邮件标题",
    sendCount:"发送数量",
    sucCount:"成功数量",
    failCount:"失败数量",
    updateDate: '更新时间',
    sendType:"发送类型",
    chooseTemplate:"模板选择",
    content:"邮件内容",
    receiver:"收件人",
    uploadReceiver:"上传电邮名单",
    emailList:"电邮名单",
    uploadTip:'将文件拖到此处，或',
    uploadTip1:'点击上传',
    uploadTip2:'1、多个邮箱英文逗号隔开',
    uploadTip3:'2、每次上传将覆盖之前邮箱',
    uploadTip4:'3、每次发送不能超过5千个邮箱，超过可分开多次发送',
    uploadTip5:'4、电邮名单只支援.txt或.csv档案格式',
    uploadTip6:'1、附件只支援.pdf档案格式',
    uploadTip7:'2、附件每个大小不能超过10MB',
    uploadSuc:'文件上传成功',
    uploadFail:'文件上传失败',
    uploadFile:'立即上传',
    attachment:'附件',
    selectAttachment:'选择附件',
    deleteAll:'全部刪除',
    chooseChannel:"通道选择",
    sender:"寄件人",
  },
  emailChannel:{
    emailChannel:"邮件通道",
    channelName:"通道名称",
    emailAddress:"电邮地址",
    enabled:"状态",
    updateDate: '更新时间',
  },
  agent:{
    name: "姓名",
    identityCardNumber: "身份证号码",
    phoneNumber: "电话",
    emailAddress: "电子邮件",
    qqAccount: "QQ",
    wechatAccount: "微信",
    companyName: "公司名称",
    companyLink: "公司网站",
    createdTime: "加入时间",
    confirmDownload: "此操作将下载文件, 是否继续?",
    confirmMessageTitle: "提示",
    confirmButton: "确定",
    cancleButton: "取消",
    cancleMessage: "已取消",
    isValid: "有效客户",
    isValidPlaceholder: "请选择",
    isValidDefault: "未选择",
    isValidTrue: "有效客户",
    isValidFalse: "无效客户",
    confirmValidate: "确认更改客户状态吗?",
  },
  appProduct:{
    queryForm: {
      label: {
        chineseName: "产品中文名",
        englishName: "产品英文名",
        platform: "应用平台",
        accountType: "账户类型",
        channel: "渠道",
      },
      placeholder: {
        chineseName: "产品中文名",
        englishName: "产品英文名",
        platform: "应用平台",
        accountType: "账户类型",
        channel: "渠道",
      },
    },
    addForm: {
      title: "新增",
      label: {
        platform: "应用平台",
        englishName: "产品英文",
        accountType: "账户类型",
        channel: "渠道",
        sortOrder: "排序",
      },
      placeholder: {
        englishName: "产品英文",
      },
    },
    updateForm: {
      title: "修改",
      label: {
        platform: "应用平台",
        englishName: "产品英文",
        accountType: "账户类型",
        channel: "渠道",
        sortOrder: "排序",
      },
      placeholder: {
        englishName: "产品英文",
      },
    },
    table: {
      code: "产品代码",
      iCodeId: "iCodeId",
      chineseName: "产品中文名",
      englishName: "产品英文名",
      platform: "应用平台",
      channel: "渠道",
      accountType: "账户类型",
      sortOrder: "排序",
      createdDate: "创建日期",
      updatedDate: "修改日期",
    },
    button: {
      queryAppProduct: "查询",
      addAppProduct: "新增产品",
      updateAppProduct: "编辑产品",
      deleteAppProduct: "删除产品",
      setAmountField: "预设产品个数",
    },
    other: {
      setAmountFieldLabel:"预设产品个数",
      setAmountFieldPlaceholder:"未设置",
      exceedProductAmount: "超出单渠道产品数上限15个",
    }
  },
  optional:{
    iCodeId: "code",
    symbol: "产品编码",
    platform: "平台",
    businessType: "业务组",
    accountNo: "账号",
    account: "用户",
    createTime: "创建时间",
    channel: "渠道",
  },
  nps:{
    npsId: "回复序号",
    realAccount: "真实账号",
    simAccount: "模拟账号",
    mobile: "手机号",
    score: "推荐程度",
    npsType: "回复种类",
    comment: "回复内容",
    createdTime: "创建时间",
    deviceOs: "平台",
    appVersion: "客户端版本",
    socreRange: "推荐程度范围",
    accountType: "账号类型",
    accountTypeOption1: "全部",
    accountTypeOption2: "真实账号",
    accountTypeOption3: "模拟账号",
    accountTypeOption4: "全部（排除测试账号）",
    accountTypeOption5: "真实账号（排除测试账号）",
    accountTypeOption6: "模拟账号（排除测试账号）",
    isTestingAccount: "是否测试账号",
    isTestingAccountTrue: "是",
    isTestingAccountFalse: "否",
    checkCommentButton: "查看回复",
    confirmDownload: "此操作将下载文件, 是否继续?",
    confirmMessageTitle: "提示",
    confirmButton: "确定",
    cancleButton: "取消",
    cancleMessage: "已取消",
    refreshChartButton: "刷新图表",
    barChartLabel: "NPS值",
    barChartXAxisName: "分数",
    barChartYAxisName: "评分人数",
    pieChartPositiveTitle: "推荐型反馈种类",
    pieChartPositiveSubTitle: "正项反馈",
    pieChartNegativeTitle: "批评型反馈种类",
    pieChartNegativeSubTitle: "负项反馈",
    pirChartLegend1: "产品杠杆",
    pirChartLegend2: "产品丰富度",
    pirChartLegend3: "实时资讯",
    pirChartLegend4: "分析师",
    pirChartLegend5: "极速开户",
    pirChartLegend6: "极速出入金",
    pirChartLegend7: "客户服务",
    pirChartLegend8: "交易产品体验",
    pirChartLegend9: "优惠活动",
    pirChartLegend10: "其他",
  },
  lp:{
    name: "姓名",
    phoneNumber: "电话",
    sourceUrl: "来源网站",
    createdTime: "日期",
    confirmDownload: "此操作将下载文件, 是否继续?",
    confirmMessageTitle: "提示",
    confirmButton: "确定",
    cancleButton: "取消",
    cancleMessage: "已取消",
  },
  feedback:{
    queryForm: {
      label: {
        accountType: "账号类型",
        realAccount: "真实账号",
        demoAccount: "模拟账号",
        createdTime: "创建时间",
        createdTimeTo: "至",
        channel: "渠道来源",
        contact: "联系方式",
        hasImage: "图片",
        validateStatus: "有效状态",
        accountStatus: "帐号状态",
        platform: "应用平台"
      },
      placeholder: {
        realAccount: "真实账号",
        demoAccount: "模拟账号",
        createdStartTime: "创建时间开始时间",
        createdEndTime: "创建时间结束时间",
        contact: "不限制",
        hasImage: "不限制",
        validateStatus: "不限制",
        platform: "不限制",
      },
      option: {
        accountType: {
          all: "全部",
          realAccount: "真实账号",
          demoAccount: "模拟账号",
          visitor: "游客",
        },
        contact: {
          any: "不限制",
          phone: "手机号",
          wechat: "微信号",
        },
        image: {
          any: "不限制",
          has: "有",
          no: "无",
        },
        validateStatus: {
          any: "不限制",
          valid: "有效",
          invalid: "无效",
        },
        channel: {
          placehoder: "全部"
        },
        accountStatus: {
          any: "不限制",
          test: "测试账号",
          real: "非测试账号",
        },
        platform: {
          any: "不限制",
          app: "App",
          mobile: "M端",
          pc: "PC"
        }
      },
      button: {
        query: "查询",
        download: "加密下载",
        export: "导出",
      },
      messageBox: {
        title: "提示",
        message: "此操作将下载文件, 是否继续?",
        confirm: "确认",
        cancel: "取消",
        cancleMessage: "已取消",
      }
    },
    table: {
      header: {
        feedbackNo: "回馈建议序号",
        realAccount: "真实账号",
        demoAccount: "模拟账号",
        phone: "手机号",
        wechat: "微信",
        feedbackType: "建议类型",
        description: "建议内容",
        createdTime: "创建时间",
        platform: "应用平台",
        channel: "渠道",
        appVersion: "客户端版本",
        hasImage: "图片",
        isTestingAccount: "测试账号",
        operation: "操作",
      },
      button: {
        view: "查看",
        validate: "检验",
        valid: "有效",
        invalid: "无效",
      },
      messageBox: {
        title: "确认",
        message: "你确定将这则建议改为【{status}】吗？",
        confirm: "确认",
        cancel: "取消",
        cancleMessage: "已取消",
      },
      value: {
        true: "是",
        false: "否",
      }
    },
    modal: {
      title: "建议内容",
      label: {
        content: "建议内容",
        image: "上传图片",
      },
      close: "关闭",
      confirm: "确认",
    }
  },
  vpnConfig:{
    queryForm:{
      label:{
        node: "站点",
        domain: "域名",
        ip:"IP位置",
        isValid:"有效状态"
      },
      placeholder:{
        node: "查询站点",
        domain: "查询域名",
        ip:"查询IP位置",
        isValid:"不限定VPN配置状态"
      },
      optionList:{
        any:"不限定",
        valid:"有效",
        invalid:"无效"
      },
      button:{
        query:"查询",
        reset:"重置",
        add:"新增"
      }
    },
    table:{
      header:{
        node:"站点",
        domain:"域名",
        ip:"IP位置",
        remark:"备注",
        createdBy:"新增人员",
        createdAt:"新增时间",
        updatedBy:"更新人员",
        updatedAt:"更新时间",
        operation:"操作"
      },
      button:{
        validate: "检验",
        valid:"有效",
        invalid:"无效",
        modify:"修改",
        delete:"删除"
      }
    },
    messageBox:{
      validate:{
        title: "确认",
        message: "你确定将这个VPN配置改为【{status}】吗？",
      },
      delete:{
        title: "确认",
        message: "你确定删除这个VPN配置吗？",
      },
      button:{
        confirm:"确认",
        cancel:"取消"
      },
      cancleMessage: "已取消",
    },
    modal:{
      create:{
        title:"新增VPN配置",
      },
      update:{
        title:"修改VPN配置",
      },
      label:{
        node:"站点名称",
        domain:"VPN配置域名",
        ip:"IP位置",
        config:"VPN配置内容",
        remark:"备注",
      },
      placeholder:{
        node:"站点名称",
        domain:"可配置多个域名，使用逗点分隔",
        ip:"IPv4格式;可配置多个IP，使用逗点分隔",
        config:"对应的VPN配置字串",
        remark:"选填",
      },
      button:{
        create:"新增",
        update:"修改",
        cancel:"取消"
      },
      message:{
        successCreate: "新增配置成功",
        successUpdate: "修改配置成功"
      }
    }
  },
  appAbChannel: {
    common: {
      id: "ID",
      filename: "_可用地区列表_",
      emptyArea: "未设定"
    },
    message:{
      invalid: "无效操作",
      success: "请求成功",
      fail: "请求失败",
      unknown: "未知错误"
    },
    form: {
      appName: {
        label: "应用名称",
        placeholder: "支持名称模糊查詢"
      },
      status: {
        label: "开启状态",
        placeholder: "全部"
      },
      area: {
        label: "开启城市",
        placeholder: "查询城市名称"
      },
      button: {
        blacklist: "IP黑名单管理"
      }
    },
    table: {
      appName: "应用名称",
      appFlavor: "应用标识",
      status: "B包开启状态",
      area: "开启地区（城市）",
      createdAt: "创建时间",
      createdBy: "创建人",
      updatedAt: "更新时间",
      updatedBy: "更新人",
      operation: {
        export: "地区下载"
      }
    },
    modal: {
      appName: {
        label: "应用名称",
        placeholder: "请输入应用名称"
      },
      appFlavor: {
        label: "APP标识",
        placeholder: "请输入APP标识"
      },
      status: {
        label: "状态",
        placeholder: "请选择状态"
      },
      area: {
        label: "开启地区范围",
        placeholder: "请选择开启地区范围",
        button: "上传地区名单"
      },
      remark: {
        label: "备注",
        placeholder: "备注(可选)"
      }
    },
    blacklist: {
      title: "IP黑名单管理",
      message: {
        invalid: "无效的IP地址格式"
      },
      table: {
        id: "ID",
        ipAddress: "IP地址",
        remark: "备注"
      },
      modal: {
        title: "添加IP黑名单",
        ipAddress: {
          label: "IP地址",
          placeholder: "如：192.168.1.1"
        },
        remark: {
          label: "备注",
          placeholder: "备注(可选)"
        }
      }
    }
  },
  appChannel: {
    message: {
      invalid: "无效操作",
      success: "请求成功",
      fail: "请求失败",
      unknown: "未知错误",
      duplicate: "与已有数据重复",
    },
    form: {
      name: {
        label: "渠道名称",
      },
      flavor: {
        label: "渠道包名称"
      },
      os: {
        label: "操作系统"
      },
      client: {
        label: "前端页面"
      }
    },
    table: {
      name: "渠道名称",
      flavor: "渠道包名称",
      os: "操作系统",
      client: "前端页面"
    },
    modal: {
      name: {
        label: "渠道名称",
        placeholder: "请输入渠道名称"
      },
      flavor: {
        label: "渠道包名称",
        placeholder: "请输入渠道包名称"
      },
      os: {
        label: "操作系统"
      },
      client: {
        label: "前端页面"
      }
    }
  }
};
